const analytics = () => ({
  logEvent: () => Promise.resolve(),
  setUserId: () => Promise.resolve(),
  setUserProperty: () => Promise.resolve(),
  setUserProperties: () => Promise.resolve(),
  setAnalyticsCollectionEnabled: () => Promise.resolve(),
  resetAnalyticsData: () => Promise.resolve(),
  logScreenView: () => Promise.resolve(),
});

export default analytics;
